import 'raf/polyfill'
import 'babel-polyfill'
import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link} from "react-router-dom"
import './return-m.css'
import Authenticate from '../../component/authenticate/authenticate.js'
import HeaderM  from '../../component/headerM/headerM.js'
import {authenticationFn} from '../../redux/chatuser.redux.js'
import {authenMsg} from '../../redux/chatuser.redux.js'
import {userList} from '../../redux/chatuser.redux.js'

@connect(
  state=>state.chatuser,
  {userList,authenticationFn,authenMsg}
)
class ReturnM extends React.Component{
	constructor(props){
		super(props)
		this.state={
			gameList:null,
			detailVla:'',
			authenticationData:''
    	}
    	this.handleVla = this.handleVla.bind(this)
    	this.authenticationDataFn = this.authenticationDataFn.bind(this)
	}
	componentDidMount(){
  		document.title = '心享俱乐部—回归特权'
		
    	this.getAllGames()
    		
    	
  	}
  	getAllGames(){
  		axios.get('/fapi/recom/getAllGames?page=0&limit=0')
  			.then(res=>{
  				
  				if(res.data.return_code===0){
  					
  					if(this.state.authenticationData.game_often){

			  			for(let i=0;i<this.state.authenticationData.game_often.length;i++){
			  				for(let j=0;j<res.data.data.length;j++){

			  					if(this.state.authenticationData.game_often[i].game_id==res.data.data[j].game_id){
			  						
			  						var idata = res.data.data
			  						idata[j].onOff = true
			  						this.setState({
										gameList:idata
			  						})
			  					}
			  				 }
			  			}
			  		}else{
			  			this.setState({
  							gameList:res.data.data
  						})
			  		}
  				}
  				
  				
  			})
  		
  	} 
  	handleVla(data){
  		this.setState({
  			detailVla:data
  		})
  	}
  	authenticationDataFn(data){
  		
  		this.setState({
  			authenticationData:data
  		},function () {
  			this.getAllGames()
  		})
  	}
  	handleLink(item){
  		 		
  		this.props.history.push('/return-detail/'+item.game_id)
  		this.props.authenMsg(this.state.detailVla)

  	}
  	render(){
  		
  		return (

			<div className="return-box-m">
				<HeaderM></HeaderM>
				<section className="return-sec1">
					<div className="authenticate-m-box">
						<Authenticate
							handleVla={this.handleVla} 
							authenticationDataFn={this.authenticationDataFn}
							
						></Authenticate>
					</div>
				
				</section>
				<section className="return-sec2">
					<h6>目前回归特权已开放游戏共 <i>{this.state.gameList&&this.state.gameList.length}</i> 款</h6>
					<div className="return-game-list">
						<span className="return-game-icon1"></span>
						<ul>
							{this.state.gameList&&this.state.gameList.map((item,i)=>{
								return (
									<li key={i}>
										<div className="list-img" style={{backgroundImage:'url('+item.newgamepage_img+')'}}></div>
										<div className="list-info">
											<div className="list-middle">
												{item.onOff&&<span></span>}
												<div className="game-name">{item.gamename}</div>
											</div>
											<a onClick={()=>this.handleLink(item)} 
											 href="javascript:;"></a>
										</div>
										
									</li>

								)
							})}
							


						</ul>
					</div>
				</section>
			</div>
  		)
  	}
}

export default ReturnM




// WEBPACK FOOTER //
// ./src/container/return/return-m.js